<template>
  <div class="ProjectEdit__part">
    <violet-bar>Chronologie</violet-bar>
    <help-message>
      <h3 slot="title">Chronologie</h3>
      <p>
        Les dates proposées sont un ensemble de dates courantes : si un intitulé
        est manquant, n'hésitez bien sûr pas à l'ajouter.<br />Les dates
        laissées vides ne sont pas enregistrées.
      </p>
    </help-message>
    <div>
      <table
        class="table is-hoverable is-bordered is-fullwidth is-striped is-size-7"
      >
        <thead>
          <tr>
            <td>Type de date</td>
            <td>
              <span style="display: flex"
                >Date
                <span
                  class="has-text-danger"
                  v-if="!supports"
                  style="margin-left: auto"
                  ><i class="fa fa-exclamation-circle"></i
                  >&nbsp;yyyy-mm-jj</span
                ></span
              >
            </td>
            <td>suppr.</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(date, index) in project.dates" :key="index">
            <td>
              <kv-suggestor
                :type="'dates'"
                :item="date.date_id"
                @update="update('date_id', index, $event)"
                :inline="true"
              ></kv-suggestor>
            </td>
            <td>
              <input
                type="date"
                class="input"
                v-model="date.content"
                :class="!validateHtmlDate(date.content) ? 'is-danger' : ''"
              />
            </td>
            <td>
              <button class="button is-danger" @click="remove(index)">
                <i class="fa fa-times"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="buttons">
        <button class="button" @click="addRow">Ajouter une Date</button>
      </div>
    </div>
  </div>
</template>
<script>
import VioletBar from "../VioletBar";
import KvSuggestor from "../../../components/Form/KvSuggestor";
import { cheapoClone } from "../../../util/func";
import { DefaultDate } from "../../../store/models/project";
import HelpMessage from "../../../components/Form/HelpMessage";

/**
 * Validates yyyy-mm-dd strings, ensuring that the month isn't switched with the day
 * match cannot throw since test ensures the matches presence and && short-circuits.
 * @param str
 * @returns {boolean}
 */
const validateHtmlDate = str =>
  /\d{4}-\d{2}-\d{2}/.test(str) &&
  parseInt(str.match(/(\d{4})-(\d{2})-(\d{2})/)[2], 10) <= 12;

export default {
  name: "ProjectEdit-Dates",
  components: { HelpMessage, KvSuggestor, VioletBar },
  props: {
    item: {}
  },
  data() {
    return {
      supports: false
    };
  },
  computed: {
    project: {
      get() {
        return this.item;
      },
      set(val) {
        this.$emit("update", val);
      }
    }
  },
  methods: {
    isDateSupported() {
      const input = document.createElement("input");
      const value = "a";
      input.setAttribute("type", "date");
      input.setAttribute("value", value);
      return input.value !== value;
    },
    update(key, index, value) {
      const p = cheapoClone(this.project);
      p.dates[index][key] = value;
      this.project = p;
    },
    validateHtmlDate,
    addRow() {
      const p = cheapoClone(this.project);
      p.dates.push(DefaultDate(this.project.id, null));
      this.project = p;
    },
    remove(index) {
      const p = cheapoClone(this.project);
      p.dates = p.dates.filter((a, i) => i !== index);
      this.project = p;
    }
  },
  mounted() {
    this.supports = this.isDateSupported();
  }
};
</script>
